// Keeps the address bar in sync with the event calendar's category/age
// filters. Delegated on document because Sprig replaces the calendar's
// markup on every AJAX re-render, so listeners bound directly to the
// <select> elements would be lost after the first swap.
document.addEventListener('change', (e) => {
	const filter = e.target.closest('.event-calendar__filter');
	if (!filter) return;

	const calendar = filter.closest('.event-calendar');
	if (!calendar) return;

	const params = new URLSearchParams();
	calendar.querySelectorAll('[name]').forEach((field) => {
		if (field.value) params.set(field.name, field.value);
	});

	const query = params.toString();
	window.history.pushState(null, '', window.location.pathname + (query ? `?${query}` : ''));
});
